import { EMPTY_OBJECT } from "../../utils/empty.js";
import { DISABLED_TRANSITIONS_STYLE } from "./constants.js";
function getDisabledMountTransitionStyles(transitionStatus) {
  return transitionStatus === "starting" ? DISABLED_TRANSITIONS_STYLE : EMPTY_OBJECT;
}
export {
  getDisabledMountTransitionStyles
};
//# sourceMappingURL=getDisabledMountTransitionStyles.js.map
